import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMail, FiCalendar, FiLock, FiEye, FiEyeOff, FiAlertCircle, FiArrowRight, FiArrowLeft, FiCheck } from 'react-icons/fi';
import { styles } from '../../styles';
import { validateEmailCadastro, validateDateOfBirth } from '../../../../validators';
import { verifyEmailExist } from '../../../../Api';
import { notify } from '../../../../components/Notify';

export default function Step2Docs({ next, prev, update, data }) {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [checking, setChecking] = useState(false);

    const setError = (key, msg) => setErrors(prev => ({ ...prev, [key]: msg }));
    const clearError = (key) => setErrors(prev => ({ ...prev, [key]: undefined }));

    const validateAll = () => {
        const next = {};

        const emailRes = validateEmailCadastro(data.email);
        if (!emailRes.valid) next.email = emailRes.error;

        if (!data.confirmEmail) {
            next.confirmEmail = 'Confirme o e-mail.';
        } else if ((data.email || '').trim() !== (data.confirmEmail || '').trim()) {
            next.confirmEmail = 'Os e-mails não coincidem.';
        }

        const dobRes = validateDateOfBirth(data.dataNascimento);
        if (!dobRes.valid) next.dataNascimento = dobRes.error;

        if (!data.password) {
            next.password = 'Defina uma senha.';
        } else if (data.password.length < 6) {
            next.password = 'Senha deve ter pelo menos 6 caracteres.';
        }

        if (!data.aceitouTermos) {
            next.aceitouTermos = 'Você precisa concordar com os termos para continuar.';
        }

        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleNext = async () => {
        if (!validateAll()) return;
        if (checking) return;

        // Pre-check: se o email já existe, redireciona pro login (já pré-preenchido
        // via location.state). UX preferível a deixar falhar só na criação.
        setChecking(true);
        try {
            const emailNorm = (data.email || '').trim().toLowerCase();
            const res = await verifyEmailExist({ userEmail: emailNorm });
            const exists = String(res.data?.message || '').toLowerCase().includes('já cadastrado');
            if (exists) {
                notify('Email já cadastrado. Redirecionando para o login…', 'warning');
                setTimeout(() => {
                    navigate('/login', { state: { prefilledEmail: emailNorm } });
                }, 1200);
                return;
            }
        } catch (err) {
            console.warn('Falha ao verificar email:', err);
        } finally {
            setChecking(false);
        }

        next();
    };

    // Limita data máxima a hoje e mínima a 100 anos atrás (UX no date picker nativo)
    const today = new Date();
    const maxDate = today.toISOString().split('T')[0];
    const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate())
        .toISOString().split('T')[0];

    return (
        <div>
            {/* E-mail */}
            <div style={styles.inputGroup}>
                <label style={styles.label} htmlFor="email">E-mail</label>
                <div style={styles.inputWrapper}>
                    <span style={styles.inputIcon}><FiMail size={18} /></span>
                    <input
                        id="email"
                        type="email"
                        placeholder="seu@email.com"
                        autoComplete="email"
                        value={data.email || ''}
                        onChange={(e) => { update({ email: e.target.value }); if (errors.email) clearError('email'); }}
                        onFocus={(e) => e.target.style.borderColor = '#10B981'}
                        onBlur={(e) => {
                            e.target.style.borderColor = errors.email ? '#F43F5E' : '#E2E8F0';
                            if (data.email) {
                                const r = validateEmailCadastro(data.email);
                                setError('email', r.valid ? undefined : r.error);
                            }
                        }}
                        style={styles.input(!!errors.email)}
                    />
                </div>
                {errors.email && (
                    <div style={styles.fieldError}><FiAlertCircle size={14} /> {errors.email}</div>
                )}
            </div>

            {/* Confirmar E-mail */}
            <div style={styles.inputGroup}>
                <label style={styles.label} htmlFor="confirmEmail">Confirmar e-mail</label>
                <div style={styles.inputWrapper}>
                    <span style={styles.inputIcon}><FiMail size={18} /></span>
                    <input
                        id="confirmEmail"
                        type="email"
                        placeholder="Repita o e-mail"
                        autoComplete="email"
                        value={data.confirmEmail || ''}
                        onChange={(e) => { update({ confirmEmail: e.target.value }); if (errors.confirmEmail) clearError('confirmEmail'); }}
                        onFocus={(e) => e.target.style.borderColor = '#10B981'}
                        onBlur={(e) => {
                            e.target.style.borderColor = errors.confirmEmail ? '#F43F5E' : '#E2E8F0';
                            if (data.confirmEmail && data.email && data.email.trim() !== data.confirmEmail.trim()) {
                                setError('confirmEmail', 'Os e-mails não coincidem.');
                            }
                        }}
                        style={styles.input(!!errors.confirmEmail)}
                    />
                </div>
                {errors.confirmEmail && (
                    <div style={styles.fieldError}><FiAlertCircle size={14} /> {errors.confirmEmail}</div>
                )}
            </div>

            {/* Data nascimento */}
            <div style={styles.inputGroup}>
                <label style={styles.label} htmlFor="dataNascimento">Data de nascimento</label>
                <div style={styles.inputWrapper}>
                    <span style={styles.inputIcon}><FiCalendar size={18} /></span>
                    <input
                        id="dataNascimento"
                        type="date"
                        max={maxDate}
                        min={minDate}
                        value={data.dataNascimento || ''}
                        onChange={(e) => { update({ dataNascimento: e.target.value }); if (errors.dataNascimento) clearError('dataNascimento'); }}
                        onFocus={(e) => e.target.style.borderColor = '#10B981'}
                        onBlur={(e) => {
                            e.target.style.borderColor = errors.dataNascimento ? '#F43F5E' : '#E2E8F0';
                            if (data.dataNascimento) {
                                const r = validateDateOfBirth(data.dataNascimento);
                                setError('dataNascimento', r.valid ? undefined : r.error);
                            }
                        }}
                        style={styles.input(!!errors.dataNascimento)}
                    />
                </div>
                {errors.dataNascimento && (
                    <div style={styles.fieldError}><FiAlertCircle size={14} /> {errors.dataNascimento}</div>
                )}
            </div>

            {/* Senha */}
            <div style={styles.inputGroup}>
                <label style={styles.label} htmlFor="password">Senha de acesso</label>
                <div style={styles.inputWrapper}>
                    <span style={styles.inputIcon}><FiLock size={18} /></span>
                    <input
                        id="password"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="No mínimo 6 caracteres"
                        autoComplete="new-password"
                        value={data.password || ''}
                        onChange={(e) => { update({ password: e.target.value }); if (errors.password) clearError('password'); }}
                        onFocus={(e) => e.target.style.borderColor = '#10B981'}
                        onBlur={(e) => {
                            e.target.style.borderColor = errors.password ? '#F43F5E' : '#E2E8F0';
                            if (data.password && data.password.length < 6) {
                                setError('password', 'Senha deve ter pelo menos 6 caracteres.');
                            }
                        }}
                        style={styles.input(!!errors.password)}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(s => !s)}
                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                        style={{
                            position: 'absolute', right: '0.5rem',
                            background: 'transparent', border: 'none', cursor: 'pointer',
                            padding: '0.4rem', color: '#64748B',
                            display: 'grid', placeItems: 'center', borderRadius: 6,
                        }}
                    >
                        {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                    </button>
                </div>
                {errors.password && (
                    <div style={styles.fieldError}><FiAlertCircle size={14} /> {errors.password}</div>
                )}
            </div>

            {/* Consentimento — obrigatório antes da criação da conta no Step 3 */}
            <div style={consentStyles.wrapper}>
                <label style={consentStyles.row}>
                    <input
                        type="checkbox"
                        checked={!!data.aceitouTermos}
                        onChange={(e) => {
                            update({ aceitouTermos: e.target.checked });
                            if (errors.aceitouTermos) clearError('aceitouTermos');
                        }}
                        style={consentStyles.hiddenInput}
                    />
                    <span
                        style={{
                            ...consentStyles.box,
                            ...(data.aceitouTermos ? consentStyles.boxChecked : {}),
                            ...(errors.aceitouTermos ? consentStyles.boxError : {}),
                        }}
                        aria-hidden="true"
                    >
                        {data.aceitouTermos && <FiCheck size={14} color="#fff" strokeWidth={3} />}
                    </span>
                    <span style={consentStyles.text}>
                        Declaro que as informações fornecidas são <strong>verdadeiras</strong> e concordo com a{' '}
                        <a href="/politicadeprivacidade" target="_blank" rel="noopener noreferrer" style={consentStyles.link}>
                            Política de Privacidade
                        </a>{' '}
                        e os{' '}
                        <a href="/termosdeuso" target="_blank" rel="noopener noreferrer" style={consentStyles.link}>
                            Termos de Uso
                        </a>
                        <p></p>
                        Os dados fornecidos serão utilizados <strong>exclusivamente</strong> pela UEN para a emissão da carteirinha de estudante digital. Em caso de aquisição da carteira física, somente as informações necessárias para sua confecção serão utilizadas.
                    </span>
                </label>
                {errors.aceitouTermos && (
                    <div style={{ ...styles.fieldError, marginTop: '0.4rem' }}>
                        <FiAlertCircle size={14} /> {errors.aceitouTermos}
                    </div>
                )}
            </div>

            <button
                onClick={handleNext}
                disabled={checking}
                style={{
                    ...styles.signUpButton,
                    ...(checking ? { opacity: 0.7, cursor: 'not-allowed' } : {}),
                }}
            >
                {checking ? 'Verificando…' : <>Próximo <FiArrowRight size={18} /></>}
            </button>
            <button
                onClick={prev}
                style={{
                    ...styles.secondaryButton,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem',
                }}
            >
                <FiArrowLeft size={16} /> Voltar
            </button>
        </div>
    );
}

const consentStyles = {
    wrapper: {
        margin: '0.5rem 0 1rem',
        padding: '0.85rem 1rem',
        background: '#F8FAFC',
        border: '1px solid #E2E8F0',
        borderRadius: 10,
    },
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.65rem',
        cursor: 'pointer',
    },
    hiddenInput: {
        position: 'absolute',
        opacity: 0,
        width: 0,
        height: 0,
        pointerEvents: 'none',
    },
    box: {
        flexShrink: 0,
        width: 20,
        height: 20,
        borderRadius: 5,
        border: '1.5px solid #CBD5E1',
        background: '#FFFFFF',
        display: 'grid',
        placeItems: 'center',
        marginTop: 2,
        transition: 'background 0.15s ease, border-color 0.15s ease',
    },
    boxChecked: {
        background: '#059669',
        borderColor: '#059669',
    },
    boxError: {
        borderColor: '#F43F5E',
    },
    text: {
        fontSize: '0.825rem',
        lineHeight: 1.5,
        color: '#475569',
    },
    link: {
        color: '#059669',
        fontWeight: 600,
        textDecoration: 'underline',
    },
};
